import {ExchangeSearchParamType} from "../interface";
import React, {Dispatch, SetStateAction, useEffect} from "react";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import {SubmitHandler, useForm} from "react-hook-form";
import moment from "moment";
import {useUser} from "../../../../../util/userContext/UserContext";
import {useModal} from "../../../../../hooks";
import {useReadExchangeType1SelectBox} from "../../../../customer/correspondent/detail/hooks";

interface PropsType {
    searchParam: ExchangeSearchParamType
    setSearchParam: Dispatch<SetStateAction<ExchangeSearchParamType>>
    searchCallback: (data: any) => any
}

export default function Filter({searchParam, setSearchParam, searchCallback}: PropsType) {
    const {goToNavigation} = useGoToNavigation();
    const {user} = useUser();
    const {handleModal} = useModal();

    const {register, handleSubmit, getValues, setValue, watch} = useForm({
        defaultValues: searchParam,
    });

    const {data: exchangeTypeSelect1} = useReadExchangeType1SelectBox();

    const watchKeywordType2 = watch("keywordType2")
    useEffect(() => {
        switch (watchKeywordType2) {
            case "200":
                setValue("startAt", moment().format("YYYY-MM-DD"))
                setValue("endAt", moment().format("YYYY-MM-DD"))
                setValue("keywordType2Name", "당일")
                break;
            case "201":
                setValue("startAt", moment().startOf("month").format("YYYY-MM-DD"))
                setValue("endAt", moment().format("YYYY-MM-DD"))
                setValue("keywordType2Name", "당월 평균")
                break;
            case "202":
                setValue("startAt", moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"))
                setValue("endAt", moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"))
                setValue("keywordType2Name", "전월 평균")
                break;
            case "203":
                setValue("keywordType2Name", "기간평균")
                break;
            case "204":
                setValue("startAt", moment().startOf("month").format("YYYY-MM-DD"))
                setValue("endAt", moment().format("YYYY-MM-DD"))
                setValue("keywordType2Name", "당월최저")
                break;
            case "205":
                setValue("keywordType2Name", "지정일")
                break;
        }
    }, [watchKeywordType2]);

    const watchStartAt = watch("startAt")
    useEffect(() => {
        if (getValues("keywordType2") === "205") {
            setValue("endAt", watchStartAt)
        }
    }, [watchStartAt]);

    const watchEndAt = watch("endAt")
    useEffect(() => {
        if (getValues("keywordType2") === "205") {
            setValue("startAt", watchEndAt)
        }
    }, [watchEndAt]);

    /*
    const btnGoToCreate = () => {
        goToNavigation(`main/exchange/create`, {}, false)
    }
    * */

    const onSubmit: SubmitHandler<ExchangeSearchParamType> = (submitData) => {
        if (getValues("keywordType2") === "205" && getValues("startAt") !== getValues("endAt")) {
            handleModal({
                isOpen: true,
                contents: "지정일은 범위 형식일 수 없습니다.",
                type: "alert",
            });
        } else {
            setSearchParam(submitData);
            searchCallback(submitData)
        }
    };

    return <div className="fiter_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">환율정보 검색</h3>
            <div className="filter_toolbar">
                {/*
                {user && user.inOutFlag === 0 &&
                    <button type="button" className="btn btn-primary w-100px ms-5px h-38px" onClick={btnGoToCreate}>
                        생성
                    </button>}
                * */}
            </div>
        </div>
        <form className="row" onSubmit={handleSubmit(onSubmit)}>
            <div className="col-6">
                <div className="frm_row search justify-content-start">
                    <label htmlFor="" className="form-label frm_label">고시회차</label>
                    <select className="form-select w-150px"
                            {...register("keywordType")}>
                        <option value={"300"}>최초</option>
                        <option value={"301"}>최종</option>
                    </select>
                </div>
            </div>
            {/* TODO: datepicker range 브라우저 너비 줄어들면 컨테이너 벗어남 */}
            <div className="col-6">
                <div className="frm_row">
                    <label htmlFor="" className="form-label frm_label">기준</label>
                    <div className="frm_field">
                        <select className="form-select w-150px"
                                {...register("keywordType2")}
                        >
                            {exchangeTypeSelect1?.map((item) => {
                                return <option value={item.id}>{item?.name}</option>;
                            })}
                        </select>
                        <div className="frm_field input_date">
                            <input type="date" className="form-control"
                                   max="9999-12-31"
                                   disabled={
                                       getValues("keywordType2") === "200" ||
                                       getValues("keywordType2") === "201" ||
                                       getValues("keywordType2") === "202" ||
                                       getValues("keywordType2") === "204"
                                   }
                                   {...register("startAt")}
                            />
                            <span className="txt_range">~</span>
                            <input type="date" className="form-control"
                                   max="9999-12-31"
                                   disabled={
                                       getValues("keywordType2") === "200" ||
                                       getValues("keywordType2") === "201" ||
                                       getValues("keywordType2") === "202" ||
                                       getValues("keywordType2") === "204"
                                   }
                                   {...register("endAt")}
                            />
                            <button className="btn btn-info btn_search">
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
}